/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_ApplicationsInputs */

const en_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

const fr_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatures`)
};

const es_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes`)
};

const it_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature`)
};

const nl_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitaties`)
};

const pl_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje`)
};

const fi_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetetyt hakemukset`)
};

const da_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgninger`)
};

const sv_dashboard_stat_applications = /** @type {(inputs: Dashboard_Stat_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningar`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Dashboard_Stat_ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_applications = /** @type {((inputs?: Dashboard_Stat_ApplicationsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_ApplicationsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_stat_applications(inputs)
	if (locale === "fr") return fr_dashboard_stat_applications(inputs)
	if (locale === "es") return es_dashboard_stat_applications(inputs)
	if (locale === "it") return it_dashboard_stat_applications(inputs)
	if (locale === "nl") return nl_dashboard_stat_applications(inputs)
	if (locale === "pl") return pl_dashboard_stat_applications(inputs)
	if (locale === "fi") return fi_dashboard_stat_applications(inputs)
	if (locale === "da") return da_dashboard_stat_applications(inputs)
	if (locale === "sv") return sv_dashboard_stat_applications(inputs)
	return en_dashboard_stat_applications(inputs)
});